import React, { useEffect, useState } from "react";
import { QRCode } from "react-qrcode-logo";
import { Card, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { rewardService } from "../services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { authService } from "../services";
import DOMPurify from "dompurify";

const ClaimedRewards = () => {
  const [myrewards, setMyRewards] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedReward, setSelectedReward] = useState(null);

  const [isGift, setIsGift] = useState(false);
  const [email, setEmail] = useState("");

  // QR Model
  const [showQRModal, setShowQRModal] = useState(false);
  const [qrValue, setQrValue] = useState("");

  const [quadrenetProfile, setQuadrenetProfile] = useState("");

  useEffect(() => {
    getMyRewardsList();
    getQuadranetProfileDetails();
  }, []);

  // Fetch_Rewards_List
  const getMyRewardsList = async () => {
    try {
      const res = await rewardService.getMyRewards();
      if (res && res.data) {
        setMyRewards(res.data);
        // toast.success(res.message);
      }
    } catch (error) {
      console.log("Error fetching rewards list");
    }
  };

  //  Handle Gift Card
  const handleSendGift = async () => {
    if (!email) return;
    try {
      const res = await rewardService.getGiftRewards({
        rewardId: selectedReward.id,
        toEmail: email,
      });
      if (res && res.data) {
        setShowModal(false);
        setEmail("");
        getMyRewardsList();
      }
    } catch (error) {
      console.log("Error sending gift");
    }
  };

  // Fetch_QuadranetProfile_List
  const getQuadranetProfileDetails = async () => {
    try {
      const res = await authService.getQuadranetProfile();
      if (res && res.data) {
        setQuadrenetProfile(res.data?.user?.swipeNo);
      }
    } catch (error) {
      console.log("Error fetching rewards list");
    }
  };

  // Open Modal with Reward Details
  const handleCardClick = (reward) => {
    setSelectedReward(reward);
    setShowModal(true);
  };

  return (
    <div className="tab-content-container">
      <Card className="reward-card p-5">
        <h5>My Rewards</h5>
        <p className="section-subtitle">
          To use, tap redeem and show the voucher code to your  server
        </p>

        {myrewards.length > 0 ? (
          myrewards.map((reward, index) => (
            <Card
              key={index}
              className="reward-card"
              onClick={() => handleCardClick(reward)}
            >
              <Row className="no-guttersb responsive-mb">
                <Col md={5} className="position-relative">
                  <Card.Img
                    src={reward.image}
                    alt="Reward"
                    className="reward-image "
                  />
                  <div className="points-label">
                    {reward.pointsValue} Points
                  </div>
                </Col>
                <Col md={7} className="position-relative23">
                  <Card.Body>
                    <Card.Title className="reward-title">
                      {reward.title}
                    </Card.Title>
                    <Card.Text
                      className="reward-desc change-ds1"
                      // dangerouslySetInnerHTML={{ __html: reward.description }}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(reward.description, {
                          FORBID_ATTR: ["style"],
                          FORBID_TAGS: ["style"],
                        }),
                      }}
                    />
                    <Button
                      className="me-2 redeem-btn custom-bt-design1"
                      style={{
                        color: "#FB4C41",
                        border: "1px solid #FB4C41",
                        borderRadius: "0",
                        backgroundColor: "white",
                      }}
                      onClick={(e) => {
                        debugger;
                        e.stopPropagation();
                        setSelectedReward(reward);
                        setQrValue(reward.title || "No Value");
                        setShowQRModal(true);
                      }}
                    >
                      REDEEM
                    </Button>
                    <Button
                      className="gift-btn custom-bt-design1"
                      style={{
                        color: "#FB4C41",
                        border: "1px solid #FB4C41",
                        borderRadius: "0",
                        backgroundColor: "white",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedReward(reward);
                        setIsGift(true);
                        setShowModal(true);
                      }}
                    >
                      GIFT TO OTHERS
                    </Button>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          ))
        ) : (
          <p className="text-center text-muted pt-4">Earn points for 10% of your dining  spend, then select a reward from the ‘REDEEM’ tab below. Your selected  rewards will appear here.</p>
        )}
      </Card>

      {/* Reward / Gift Modal */}
      {selectedReward && (
        <Modal
          className="modelpopup222 bglc"
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
        >
          <div className="popupall">
            <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>

            <Modal.Body className="popupbody">
              <img
                src={selectedReward.image}
                alt="Reward"
                className="img-fluid rounded mb-3"
              />
              <h5 className="fw-bold">{selectedReward.title}</h5>
              <br />
              <p className="text-muted">Expiry: {selectedReward.expiryDate}</p>
              <br />
              <p className="text-muted">
                Locations: {selectedReward.locationName}
              </p>
              <br />
              <p
                className="text-muted"
                // dangerouslySetInnerHTML={{ __html: selectedReward.description }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(selectedReward.description, {
                    FORBID_ATTR: ["style"],
                    FORBID_TAGS: ["style"],
                  }),
                }}
              />

              {isGift ? (
                <>
                  <Form.Group>
                    <Form.Label>Gift to other members. Enter their loyalty email below:</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter it here"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{ marginBottom: "15px" }}
                    />
                  </Form.Group>
                  <div className="big-img-bt">
                    <Button className="popupButton" onClick={handleSendGift}>
                      SEND
                    </Button>
                  </div>
                </>
              ) : (
                <div className="big-img-bt">
                  <Button
                    className="popupButton"
                    onClick={() => setShowModal(false)}
                  >
                    CLOSE
                  </Button>
                </div>
              )}
            </Modal.Body>
          </div>
        </Modal>
      )}

      {/* QR code Model  */}
      <Modal
        className="modelpopup222 bglc"
        show={showQRModal}
        onHide={() => setShowQRModal(false)}
      >
        <Modal.Body className="popupbody text-center">
          <h5 className="mb-3">Scan to Redeem</h5>

          <QRCode
            value={
              selectedReward?.isQuadReward
                ? selectedReward.quadSwipeNo
                : quadrenetProfile
            }
            size={200}
          />

          {selectedReward?.isQuadReward ? (
            <>
              <p className="mt-3">
                <strong>Redeem Code:</strong> {selectedReward.quadSwipeNo}
              </p>
              <p className="mt-1">
                <strong>Expiry Date:</strong> {selectedReward.quadExpiryDate}
              </p>
            </>
          ) : (
            <p className="mt-3">
              <strong>Redeem Code:</strong> {quadrenetProfile}
            </p>
          )}

          <div className="big-img-bt">
            <Button
              className="popupButton"
              onClick={() => setShowQRModal(false)}
            >
              CLOSE
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ClaimedRewards;
